import SparkApi from "../../api/SparkApi";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Confirm from "../Confirm";
import { ShimmerTable } from "react-shimmer-effects";
import InfoPill from "../InfoPill";
import { usePermission } from "../context/PermissionContext";

const ProductInventory = () => {
  const navigate = useNavigate();
  const [productInventory, setProductInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [deleleteProInventoryRecord, setDeleleteProInventoryRecord] = useState(false);
  const [productInventoryRow, setProductInevtoryRow] = useState();
  const { permissionData , userInfo} = usePermission();
  const can_create = permissionData?.Product_Inventory?.can_create;

  // -start----------------- barcode ----------------
  const [barcodeRead, setBarcodeRead] = useState("");

  const barcode = {
    timing: 1000,
    data: "",
  };

  const barcodeReaded = () => {
    if (barcode.data.length > 1) {
      setBarcodeRead(barcode.data);
    } else {
      barcode.data = "";
    }
  };

  let timeout = setTimeout(barcodeReaded, 500);

  useEffect(() => {
    window.addEventListener("keypress", (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 200) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReaded, 500);
      } else {
        barcode.data = "";
      }
      // applyFilters();
    });
  }, []);
  // -end----------------- barcode ----------------

  useEffect(() => {
    fetchProductInventories();
  }, []);

  const fetchProductInventories = async () => {
    try {
      const result = await SparkApi.fetchAllProductInventory();
      if (result.success) {
        setProductInventory(result.records || []);
      } else {
        setProductInventory([]);
        setFilteredInventory([]);
      }
    } catch (error) {
      setProductInventory([]);
      setFilteredInventory([]);
    }
  };

  const handleDeleteProductInventory = async () => {
    try {
      const deletid = productInventoryRow.product_id;
      const result = await SparkApi.deleteProductInventory(deletid);
      if (result.success) {
        setDeleleteProInventoryRecord(false);
        toast.success("Product deleted successfully");
        setProductInevtoryRow(null);
        fetchProductInventories();
      } else {
        toast.error("Failed to delete the product inventory");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  const labels = {
    beforeSelect: " ",
  };

  const header = [
    {
      title: "Product Name",
      prop: "product_name",
      isSortable:true,
      cell: (row) => {
        return (
          <Link to={`/productview/${row.product_id}`}>{row.product_name}</Link>
        );
      },
      isFilterable: true,
    },
    {
      title: "Factory Name",
      prop: "factory",
      isSortable:true,
      isFilterable: true,
    },
    {
      title: "Warehouse Name",
      prop: "warehouse",
      isSortable:true,
      isFilterable: true,
    },
    {
      title: "Rack Name",
      prop: "rack",
      isFilterable: true,
      isSortable:true,
      headerClass: "rackname-column",
    },
    {
      title: "Available Quantity",
      prop: "quantity",
      isSortable:true,
      isFilterable: true,
    },
  ];

  return (
    <Container>
      <Row className="g-0">
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          theme="light"
        />

        {deleleteProInventoryRecord && (
          <Confirm
            show={deleleteProInventoryRecord}
            onHide={() => setDeleleteProInventoryRecord(false)}
            handleDeleteProductInventory={handleDeleteProductInventory}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="productInventoryDelete"
          />
        )}

        <Col lg={12}>
          <DatatableWrapper
            body={productInventory}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-4 mt-4">
              <Col xs={12} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                <Filter />
              </Col>
              <Col xs={12} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-start">
                <PaginationOptions labels={labels} />
                <div className="mt-2">
                  <InfoPill
                    left="Total Inventory"
                    right={productInventory ? productInventory.length : 0}
                  />
                </div>
              </Col>
              {(userInfo?.userrole === "ADMIN" || can_create) && 
                (<Col xs={12}
                  sm={12}
                  lg={4}
                  className="d-flex flex-col justify-content-start justify-content-sm-end align-items-end mt-2 sm-mt-0"
                >
                  <Button className="btn-sm mx-2" variant="outline-primary" onClick={() => navigate("/checkin")}>
                    Check In
                  </Button>
                  <Button className="btn-sm" variant="outline-primary" onClick={() => navigate("/checkout")}>
                    Check Out
                  </Button>
                </Col>
              )}
            </Row>
            <Table hover responsive className="data-table">
              <TableHeader />
              {productInventory ? (
                <TableBody classes="inventory-table-body" />
              ) : (
                <ShimmerTable col={5} row={5} />
              )}
            </Table>
            <Pagination />
          </DatatableWrapper>
        </Col>
      </Row>
    </Container>
  );
};
export default ProductInventory;